import React, { useContext, useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaCheck, FaMinus, FaTrash } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import buildLink from "../../../urls";
import Loader from "../../../components/loader";
import { format, subHours } from "date-fns";
import { CompanyContext } from "../../../contexts/companyCotext";
import MessageAlert from "../../../components/messageAlert";
import { PlaySounds } from "../../../functions/playSounds";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { axiosServer } from "../../../axiosServer";

const ATTRIBUTE_LABELS = {
  width: "Width",
  height: "Height",
  length: "Length",
  weight: "Weight",
};

const getMissingDimensionValues = (products, currentValues = {}) =>
  products.reduce((acc, product) => {
    const productValues = currentValues[product.product_id] ?? {};

    acc[product.product_id] = (product.attributes ?? []).reduce(
      (attributeAcc, attribute) => {
        attributeAcc[attribute] = productValues[attribute] ?? "";
        return attributeAcc;
      },
      {},
    );

    return acc;
  }, {});

const getApiPayload = (source) => {
  const candidates = [source?.data?.response, source?.data?.data, source?.data];

  return (
    candidates.find(
      (candidate) =>
        candidate &&
        (typeof candidate.success !== "undefined" ||
          Array.isArray(candidate.errors) ||
          typeof candidate.message === "string"),
    ) ||
    source?.data ||
    {}
  );
};

const JardehAddBatch = () => {
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const history = useNavigate();
  const [products, setProducts] = useState([]);
  const [productsScanned, setProductsScanned] = useState([]);
  const barcodeRef = useRef(null);
  const [modalMode, setModalMode] = useState(null);
  const [isBatchSubmitting, setIsBatchSubmitting] = useState(false);
  const [isDimensionsSubmitting, setIsDimensionsSubmitting] = useState(false);
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessgErr, setShowMessageErr] = useState(false);
  const nameBatchRef = useRef(null);
  const [batchName, setBatchName] = useState("");
  const [missingDimensionProducts, setMissingDimensionProducts] = useState([]);
  const [missingDimensionValues, setMissingDimensionValues] = useState({});
  const [missingDimensionsMessage, setMissingDimensionsMessage] = useState("");
  const [pendingBatchRequest, setPendingBatchRequest] = useState(null);
  const [stateCom, dispatchCom] = useContext(CompanyContext);
  const { name, id } = useParams();
  var host = window.location.host;

  const [selectedTab, setSelectedTab] = useState(
    host === "flo-pda.sari3.com" ||
      host === "pda.flo-leb.com" ||
      host === "pda.englishhome.com.lb"
      ? "UPC"
      : "Bin",
  );
  const canUseBinTab =
    host.startsWith("localhost") ||
    host === "pda.ishtari.com" ||
    host === "pda.energyplus-lb.com" ||
    host === "pda.ishtari.com.gh";

  const handleAddProducts = () => {
    const barcode = barcodeRef.current.value.trim();

    if (!barcode) {
      toast.error("Try Again", {
        autoClose: 500,
      });
      return;
    }

    const currentDate = new Date();
    const dateMinusTwoHours = subHours(currentDate, 2);
    let formattedDate;
    if (host === "pda.ishtari.com.gh" || host === "pda.energyplus-lb.com") {
      formattedDate = format(dateMinusTwoHours, "yyyy-MM-dd HH:mm:ss");
    } else {
      formattedDate = format(currentDate, "yyyy-MM-dd HH:mm:ss");
    }

    let obj;

    obj = {
      barcode: barcodeRef.current.value,
      date: formattedDate,
    };

    setProductsScanned((prev) => {
      const index = prev.findIndex((p) => p.barcode === barcode);

      if (index !== -1) {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          quantity: (updated[index].quantity ?? 0) + 1,
        };
        return updated;
      }

      return [...prev, { barcode, date: formattedDate, quantity: 1 }];
    });

    setProducts((prev) => [...prev, obj]);

    barcodeRef.current.value = "";
  };

  function deleteItemJarde(i) {
    const updatedProducts = [...products];

    // Remove the product at the specified index
    updatedProducts.splice(i, 1);

    // Update the state with the new array
    setProducts(updatedProducts);
  }

  function reduceItemJarde(i) {
    const scannedProduct = productsScanned[i];

    if (!scannedProduct) return;

    const barcode = scannedProduct.barcode;
    const newQuantity = (scannedProduct.quantity ?? 1) - 1;

    if (newQuantity <= 0) {
      setProductsScanned((prev) => prev.filter((_, index) => index !== i));
      setProducts((prev) => prev.filter((p) => p.barcode !== barcode));
    } else {
      setProductsScanned((prev) => {
        const updated = [...prev];
        updated[i].quantity = newQuantity;
        return updated;
      });
      setProducts((prev) => {
        const index = prev.findIndex((p) => p.barcode === barcode);
        if (index !== -1) {
          return prev.filter((_, idx) => idx !== index);
        }
        return prev;
      });
    }
  }

  const getUserIdFromLocalStorage = () => {
    return localStorage.getItem("userID");
  };

  if (host.startsWith("localhost") || host === "pda.ishtari.com") {
    const warehouse_id = stateCom?.warehouse_id;
    const warehouse_name = stateCom?.warehouse_name;

    if (warehouse_id && warehouse_name) {
      localStorage.setItem("warehouse_id", warehouse_id);
      localStorage.setItem("warehouse_name", warehouse_name);
    }
  }

  const warehouse_id = localStorage.getItem("warehouse_id");
  const warehouse_name = localStorage.getItem("warehouse_name");

  const showTimedMessage = (text, type = "success") => {
    setMessage(text);

    if (type === "success") {
      setShowMessageErr(false);
      setShowMessageSucc(true);
      setTimeout(() => {
        setShowMessageSucc(false);
      }, 3000);
      return;
    }

    setShowMessageSucc(false);
    setShowMessageErr(true);
    setTimeout(() => {
      setShowMessageErr(false);
    }, 3000);
  };

  const resetMissingDimensionsState = () => {
    setMissingDimensionProducts([]);
    setMissingDimensionValues({});
    setMissingDimensionsMessage("");
    setPendingBatchRequest(null);
  };

  const handleBatchSuccess = (successMessage) => {
    playSuccessSound();
    showTimedMessage(successMessage, "success");
    setModalMode(null);
    setBatchName("");
    resetMissingDimensionsState();
    dispatchCom({ type: "setWarehouseID", payload: "" });
    dispatchCom({ type: "setWarehouseName", payload: "" });
    localStorage.removeItem("warehouse_id");
    localStorage.removeItem("warehouse_name");
    history(-1);
  };

  const handleBatchError = (errorMessage) => {
    playErrorSound();
    showTimedMessage(errorMessage || "An error occurred", "error");
  };

  const getAddJardehUrl = () => {
    if (
      window.location.host == "pda.ishtari.com" ||
      window.location.host == "pda.ishtari.com.gh" ||
      host === "pda.energyplus-lb.com" ||
      window.location.host == "localhost:3001"
    ) {
      return buildLink("addJardehishtari");
    }

    return buildLink("addJardeh");
  };

  const buildBatchRequest = () => {
    if (!products.length) {
      toast.error("Add at least one product", {
        autoClose: 1000,
      });
      return null;
    }

    if (!batchName.trim()) {
      toast.error("Enter batch name", {
        autoClose: 1000,
      });
      return null;
    }

    const userID = getUserIdFromLocalStorage();
    const currentDate = new Date();
    const formattedDate = format(currentDate, "yyyy-MM-dd");

    const productsList = products.map((pr) => ({
      barcode: pr.barcode,
      scan_date: pr.date,
    }));

    let obj;

    if (host.startsWith("localhost") || host === "pda.ishtari.com") {
      obj = {
        jardeh_name: name,
        batch_name: batchName.trim(),
        date_start: products[0].date,
        user_id: userID,
        warehouse_id: warehouse_id,
        warehouse_name: warehouse_name,
        date_end: formattedDate,
        products: productsList,
        type: selectedTab === "Bin" ? "bin" : "upc",
      };
    } else {
      obj = {
        jardeh_name: name,
        batch_name: batchName.trim(),
        user_id: userID,
        date_start: products[0].date,
        date_end: formattedDate,
        products: productsList,
        type: selectedTab === "Bin" ? "bin" : "upc",
      };
    }

    if (id !== "new") {
      obj.jardeh_id = id;
    }

    return {
      url: getAddJardehUrl(),
      payload: obj,
    };
  };

  const openMissingDimensionsModal = (errors, request, errorMessage) => {
    setMissingDimensionProducts(errors);
    setMissingDimensionValues((currentValues) =>
      getMissingDimensionValues(errors, currentValues),
    );
    setMissingDimensionsMessage(
      errorMessage ||
        "Some products are missing width, height, length or weight.",
    );
    setPendingBatchRequest(request);
    setModalMode("dimensions");
  };

  const submitBatchRequest = async (request) => {
    setIsBatchSubmitting(true);

    try {
      const res = await axiosServer.post(request.url, request.payload);
      const responseData = getApiPayload(res);

      if (responseData?.success) {
        handleBatchSuccess(responseData?.message || "Batch added successfully");
        return { success: true, needsDimensions: false };
      }

      if (
        Array.isArray(responseData?.errors) &&
        responseData.errors.length > 0
      ) {
        playErrorSound();

        openMissingDimensionsModal(
          responseData.errors,
          request,
          responseData?.message,
        );
        return { success: false, needsDimensions: true };
      }

      handleBatchError(responseData?.message || "An error occurred");
      return { success: false, needsDimensions: false };
    } catch (e) {
      const responseData = getApiPayload(e?.response);
      const responseErrors = responseData?.errors;

      if (Array.isArray(responseErrors) && responseErrors.length > 0) {
        playErrorSound();
        handleBatchError(responseData?.message);

        openMissingDimensionsModal(
          responseErrors,
          request,
          responseData?.message,
        );
        return { success: false, needsDimensions: true };
      }

      console.log(e);
      handleBatchError(
        responseData?.message ||
          e?.response?.data?.error ||
          "An error occurred",
      );
      return { success: false, needsDimensions: false };
    } finally {
      setIsBatchSubmitting(false);
    }
  };

  async function addJardeBatch() {
    const request = buildBatchRequest();

    if (!request) {
      return;
    }

    setPendingBatchRequest(request);
    await submitBatchRequest(request);
  }

  const handleMissingDimensionChange = (productId, attribute, value) => {
    setMissingDimensionValues((prev) => ({
      ...prev,
      [productId]: {
        ...prev[productId],
        [attribute]: value,
      },
    }));
  };

  const handleDimensionsBack = () => {
    resetMissingDimensionsState();
    setModalMode("batch");
  };

  const closeModal = () => {
    resetMissingDimensionsState();
    setModalMode(null);
  };

  const submitMissingDimensions = async () => {
    const userID = getUserIdFromLocalStorage();
    const productsPayload = [];
    let hasInvalidValue = false;

    missingDimensionProducts.forEach((product) => {
      const productPayload = {
        product_id: product.product_id,
      };

      (product.attributes ?? []).forEach((attribute) => {
        const rawValue =
          `${missingDimensionValues?.[product.product_id]?.[attribute] ?? ""}`.trim();
        const parsedValue = Number(rawValue);

        if (!rawValue || Number.isNaN(parsedValue) || parsedValue <= 0) {
          hasInvalidValue = true;
          return;
        }

        productPayload[attribute] = parsedValue;
      });

      productsPayload.push(productPayload);
    });

    if (hasInvalidValue) {
      toast.error("Enter all required dimensions and weight", {
        autoClose: 1000,
      });
      return;
    }

    setIsDimensionsSubmitting(true);

    try {
      const res = await axiosServer.post(
        buildLink("addJardehMissingDimensions"),
        {
          user_id: userID,
          products: productsPayload,
        },
      );
      const responseData = getApiPayload(res);

      if (responseData?.success) {
        if (pendingBatchRequest) {
          const retryResult = await submitBatchRequest(pendingBatchRequest);

          if (!retryResult.success && !retryResult.needsDimensions) {
            resetMissingDimensionsState();
            setModalMode("batch");
          }

          return;
        }

        playSuccessSound();
        showTimedMessage(
          responseData?.message || "Product attributes updated successfully",
          "success",
        );
        closeModal();
        return;
      }

      if (
        Array.isArray(responseData?.errors) &&
        responseData.errors.length > 0
      ) {
        playErrorSound();
        openMissingDimensionsModal(
          responseData.errors,
          pendingBatchRequest,
          responseData?.message,
        );
        return;
      }

      handleBatchError(
        responseData?.message || "Failed to update product attributes",
      );
    } catch (e) {
      const responseData = getApiPayload(e?.response);
      const responseErrors = responseData?.errors;

      if (Array.isArray(responseErrors) && responseErrors.length > 0) {
        playErrorSound();
        openMissingDimensionsModal(
          responseErrors,
          pendingBatchRequest,
          responseData?.message,
        );
        return;
      }

      console.log(e);
      handleBatchError(
        responseData?.message ||
          e?.response?.data?.error ||
          "Failed to update product attributes",
      );
      setModalMode("batch");
      resetMissingDimensionsState();
    } finally {
      setIsDimensionsSubmitting(false);
    }
  };

  const handleInputClick = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    barcodeRef.current.focus();
  }, []);

  useEffect(() => {
    if (modalMode === "batch") {
      nameBatchRef.current.focus();
    }
  }, [modalMode, selectedTab]);

  return (
    <>
      <div className=" h-full bg-white">
        {modalMode && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-dblackk bg-opacity-50 w-full h-full">
            <div className="relative w-full max-w-3xl sm:max-w-full sm:px-4 md:w-[700px]">
              <div
                onClick={handleInputClick}
                className="border-0 rounded-lg shadow-lg flex flex-col w-full bg-white outline-none focus:outline-none"
              >
                <div className="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t mb-4">
                  <h3 className="text-3xl font-semibold text-center text-gray-900">
                    {modalMode === "batch"
                      ? "Batch Name"
                      : "Missing Dimensions & Weight"}
                  </h3>
                  <button
                    className="ml-auto bg-transparent text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={
                      modalMode === "batch" ? closeModal : handleDimensionsBack
                    }
                  >
                    ×
                  </button>
                </div>

                {modalMode === "batch" ? (
                  <>
                    <div className="flex justify-around w-full">
                      {canUseBinTab && (
                        <button
                          onClick={() => setSelectedTab("Bin")}
                          className={`py-2 px-4 w-full ${selectedTab === "Bin" ? "font-bold bg-dbase text-white" : ""}`}
                        >
                          Bin
                        </button>
                      )}
                      <button
                        onClick={() => setSelectedTab("UPC")}
                        className={`py-2 px-4 w-full ${selectedTab === "UPC" ? "font-bold bg-dbase text-white" : ""}`}
                      >
                        UPC
                      </button>
                    </div>

                    <div className="relative p-6 flex-auto">
                      <input
                        ref={nameBatchRef}
                        type="text"
                        value={batchName}
                        onChange={(e) => setBatchName(e.target.value)}
                        className="border border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                        placeholder="Enter Batch Name"
                      />
                    </div>

                    <div className="flex items-center p-6 border-t border-solid border-dgrey justify-between rounded-b">
                      <button
                        className="text-dbase border rounded font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                        onClick={closeModal}
                      >
                        Cancel
                      </button>
                      <button
                        className="bg-dgreen text-white active:bg-green-600 font-bold uppercase text-sm px-6 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                        onClick={addJardeBatch}
                      >
                        {isBatchSubmitting ? <Loader /> : "Submit"}
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="px-6 pt-2 text-sm text-dblack">
                      {missingDimensionsMessage}
                    </div>

                    <div
                      className="p-6 flex-auto overflow-y-auto"
                      style={{ maxHeight: "60vh" }}
                    >
                      <div className="flex flex-col gap-4">
                        {missingDimensionProducts.map((product) => (
                          <div
                            key={product.product_id}
                            className="border border-dplaceHolder rounded-md p-4"
                          >
                            <h4 className="font-semibold text-dblack mb-4">
                              Product ID: {product.product_id}
                            </h4>

                            <div className="grid gap-4 md:grid-cols-2">
                              {(product.attributes ?? []).map((attribute) => (
                                <label
                                  key={`${product.product_id}-${attribute}`}
                                  className="flex flex-col gap-2 text-sm text-dblack"
                                >
                                  <span>
                                    {ATTRIBUTE_LABELS[attribute] || attribute} *
                                  </span>
                                  <input
                                    type="number"
                                    inputMode="decimal"
                                    min="0.01"
                                    step="any"
                                    value={
                                      missingDimensionValues?.[
                                        product.product_id
                                      ]?.[attribute] ?? ""
                                    }
                                    onChange={(e) =>
                                      handleMissingDimensionChange(
                                        product.product_id,
                                        attribute,
                                        e.target.value,
                                      )
                                    }
                                    className="border border-dlabelColor outline-dbase w-full rounded-md py-3 px-2"
                                    placeholder={`Enter ${ATTRIBUTE_LABELS[attribute] || attribute}`}
                                  />
                                </label>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="flex items-center p-6 border-t border-solid border-dgrey justify-between rounded-b">
                      <button
                        className="text-dbase border rounded font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                        onClick={handleDimensionsBack}
                      >
                        Back
                      </button>
                      <button
                        className="bg-dgreen text-white active:bg-green-600 font-bold uppercase text-sm px-6 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                        onClick={submitMissingDimensions}
                      >
                        {isDimensionsSubmitting ? <Loader /> : "Submit"}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        {/* header */}
        <div className=" mb-5 sticky top-0 flex flex-col bg-white">
          <div className=" w-full bg-dbase h-16">
            <div className=" container px-3  relative flex justify-between w-full text-white  h-full my-auto">
              <div className=" flex  gap-7 flex-row justify-start">
                <button
                  onClick={() => {
                    history(-1);
                    dispatchCom({ type: "setWarehouseID", payload: "" });
                    dispatchCom({ type: "setWarehouseName", payload: "" });
                    localStorage.removeItem("warehouse_id");
                    localStorage.removeItem("warehouse_name");
                  }}
                >
                  <FaArrowLeft />
                </button>
                <h2 className=" text-xl    my-auto">Jardeh ({name && name})</h2>
              </div>
              {(host.startsWith("localhost") || host === "pda.ishtari.com") &&
                warehouse_name && (
                  <h2 className="text-xl my-auto flex">
                    Warehouse: {warehouse_name}
                  </h2>
                )}
            </div>
          </div>
        </div>

        <div className=" flex flex-col gap-3">
          <div className="container ">
            <div className=" flex flex-row justify-between items-center gap-3 ">
              <div className="relative flex-1">
                <input
                  ref={barcodeRef}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                  placeholder="Barcode"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleAddProducts();
                    }
                  }}
                />
                <div>
                  <FaTrash className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 " />
                </div>
              </div>
              {host !== "pda.englishhome.com.lb" && (
                <span>{products.length}</span>
              )}

              <button
                onClick={() => setModalMode("batch")}
                className=" bg-dbase rounded-md text-white px-4 py-4 "
              >
                {" "}
                <FaCheck size={16} />
              </button>
            </div>

            {host.startsWith("localhost") ||
            host === "pda.englishhome.com.lb" ? (
              <div className=" mt-5">
                <table className="min-w-full divide-y border border-dplaceHolder divide-dgrey  ">
                  <thead className="bg-dgrey">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3  text-xs font-medium text-dblack uppercase tracking-wider"
                      >
                        Barcode
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3  text-xs font-medium text-dblack uppercase tracking-wider"
                      >
                        Quantity
                      </th>

                      <th
                        scope="col"
                        className="px-6 py-3  text-xs font-medium text-dblack uppercase tracking-wider"
                      >
                        Reduce
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {productsScanned &&
                      productsScanned.map((product, i) => {
                        return (
                          <tr className="  border-b  border-dplaceHolder">
                            <td className=" py-2 border-r border-dplaceHolder  text-center w-fit mx-auto">
                              {product.barcode}
                            </td>
                            <td className=" py-2 border-r border-dplaceHolder text-center w-fit mx-auto">
                              {product.quantity}
                            </td>

                            <td className=" py-2 border-r border-dplaceHolder text-center w-fit mx-auto">
                              {
                                <div
                                  onClick={() => {
                                    reduceItemJarde(i);
                                  }}
                                  className=" w-fit mx-auto"
                                >
                                  <FaMinus className=" text-dbase" />
                                </div>
                              }
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className=" mt-5">
                <table className="min-w-full divide-y border border-dplaceHolder divide-dgrey  ">
                  <thead className="bg-dgrey">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3  text-xs font-medium text-dblack uppercase tracking-wider"
                      >
                        Barcode
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3  text-xs font-medium text-dblack uppercase tracking-wider"
                      >
                        Date Added
                      </th>

                      <th
                        scope="col"
                        className="px-6 py-3  text-xs font-medium text-dblack uppercase tracking-wider"
                      >
                        Delete
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {products &&
                      products.map((product, i) => {
                        return (
                          <tr className="  border-b  border-dplaceHolder">
                            <td className=" py-2 border-r border-dplaceHolder  text-center w-fit mx-auto">
                              {product.barcode}
                            </td>
                            <td className=" py-2 border-r border-dplaceHolder text-center w-fit mx-auto">
                              {product.date}
                            </td>

                            <td className=" py-2 border-r border-dplaceHolder text-center w-fit mx-auto">
                              {
                                <div
                                  onClick={() => {
                                    deleteItemJarde(i);
                                  }}
                                  className=" w-fit mx-auto"
                                >
                                  <FaTrash className=" text-dbase" />
                                </div>
                              }
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};

export default JardehAddBatch;
